/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CloudAccountNotificationArguments } from '../models/CloudAccountNotificationArguments';

export class JobMetricsReportFailedArguments {
  'cloudAccountArguments'?: CloudAccountNotificationArguments;
  /**
  * The metrics target region
  */
  'region'?: string;
  /**
  * The metrics report failure cause
  */
  'error'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudAccountArguments",
      "baseName": "cloudAccountArguments",
      "type": "CloudAccountNotificationArguments",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return JobMetricsReportFailedArguments.attributeTypeMap;
  }

  public constructor() {
  }
}

